import { Line } from './Line'
import { Milestone } from './Milestone'

export default {
  Line,
  Milestone,
}
